import { useEffect, useState } from 'react';
import { Auth0Client } from '@auth0/auth0-spa-js';

// Auth0 client setup
const auth0 = new Auth0Client({
  domain: 'gammaedge.us.auth0.com',
  clientId: 'wVRRHsX6gpIOiX3LDAVKH6wqactU0o34',
  authorizationParams: {
    redirect_uri: 'https://charts-test.gammaedge.us/auth',
    audience: 'https://gammaedge.us.auth0.com/api/v2/',
    scope: 'openid profile email name nickname',
  },
});

function App() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [message, setMessage] = useState<string>('Authorizing...');

  useEffect(() => {
    (async () => {
      try {
        const searchParams = new URLSearchParams(window.location.search);
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        let returnTo = searchParams.get('returnTo') || '/';

        if (code && state) {
          const { appState } = await auth0.handleRedirectCallback();
          if (appState?.returnTo) {
            returnTo = appState.returnTo;
          }
          window.history.replaceState({}, document.title, '/auth');
        }

        const isAuthenticated = await auth0.isAuthenticated();
        if (!isAuthenticated) {
          setMessage('Redirecting to Auth0...');
          await auth0.loginWithRedirect({
            authorizationParams: {
              redirect_uri: 'https://charts-test.gammaedge.us/auth',
            },
            appState: { returnTo },
          });
        } else {
          const token = await auth0.getTokenSilently();
          document.cookie = `Authorization=Bearer ${token}; path=/; Secure; SameSite=Lax`;

          if (returnTo !== '/' && returnTo !== '/auth/') {
            window.location.href = returnTo;
            return;
          }

          setMessage('You are authenticated!');
        }
      } catch (err) {
        console.error('Auth Error:', err);
        if (err instanceof Error) {
          setMessage(`Auth error: ${err.message}`);
        } else {
          setMessage(`Auth error: ${String(err)}`);
        }
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return (
    <div
      style={{
        position: 'relative',
        width: '100vw',
        height: '100vh',
        backgroundColor: '#0a0a23',
        backgroundImage: `url('https://charts-test.gammaedge.us/public/ge-splash.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* Logo */}
      <div style={{ paddingTop: '5rem' }}>
        <img
          src="https://charts-test.gammaedge.us/public/ge-logo.svg"
          alt="Logo"
          style={{
            width: '40rem',
            height: 'auto',
            objectFit: 'contain',
          }}
        />
      </div>

      {/* Centered Status Text */}
      <div
        style={{
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <h1
          style={{
            color: 'white',
            fontSize: '2.5rem',
            fontWeight: 'bold',
            padding: '1rem',
          }}
        >
          {message}
        </h1>
      </div>
    </div>
  );
}

export default App;
